import React from 'react'

export const IconPencil = ({ ...props }) => (
   <svg viewBox="0 0 11 11" {...props}>
      <title>{'pencil'}</title>
      <g fill="#000" fillRule="nonzero">
         <path d="M6.478 1.757L.706 7.528a.23.23 0 00-.06.106L.006 10.2a.228.228 0 00.276.276l2.568-.64c.04-.01.076-.031.105-.06l5.772-5.771-2.25-2.25zM10.157.97L9.514.327a1.163 1.163 0 00-1.606 0l-.787.787 2.249 2.25.787-.788c.214-.214.332-.5.332-.803 0-.304-.118-.589-.332-.803z" />
      </g>
   </svg>
)

export const IconClose = ({ ...props }) => (
   <svg viewBox="0 0 12 12" {...props}>
      <title>{'Close'}</title>
      <defs>
         <path
            d="M10.95 9.85L7.1 6l3.85-3.85a.777.777 0 10-1.1-1.1L6 4.9 2.15 1.05a.778.778 0 10-1.1 1.1L4.9 6 1.05 9.85a.778.778 0 101.1 1.1L6 7.1l3.85 3.85a.778.778 0 101.1-1.1"
            id="prefix__a"
         />
      </defs>
      <use fill="currentColor" fillRule="nonzero" xlinkHref="#prefix__a" />
   </svg>
)
